import React, { useState, useEffect } from "react";
import CardComponent from "../../lib/Common/Card";
import BackNextButtons from "../../lib/Common/BackNextButtons";
import { useFormik } from "formik";
import TextInputFormik from "../../lib/Common/TextInputFormik";
import { createCustomer } from "../../apis/customer";
import OfferCard from "../../lib/Common/OfferCard";
import Loader from "../../lib/Common/loader";
import { ReviewOrderSchema } from "../../validations/schema";
import { useTranslation } from "react-i18next";
import { buildWebsiteUrl } from "../../apis/apiKit";
import i18n from "../../i18n/i18n";
import { germanToUSNumber } from "../../lib/Common/definedFunctions";
const ReviewOrderTab = ({
  formData,
  updateFormData,
  currentStep,
  setCurrentStep,
  setStep,
  values,
  setShowSave,
  setBackStep,
}) => {
  const { t } = useTranslation();
  const currentLanguage = i18n.language;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [hide, setHide] = useState(false);
  const [addresses, setAddresses] = useState({
    delivery: "",
    billing: "",
  });
  useEffect(() => {
    setShowSave(false);
  }, []);
  useEffect(() => {
    if (!formData?.deliveryAddress) return;

    const delivery = formData.deliveryAddress;

    const deliveryAddress = [
      delivery?.deliv_address_street,
      delivery?.deliv_address_house_number,
      delivery?.deliv_address_zipcode,
      delivery?.deliv_address_city,
    ]
      .filter(Boolean)
      .join(", ");

    const billingAddress = delivery?.differentBillingAddress
      ? [
          delivery?.bill_address_street ?? delivery?.deliv_address_street,
          delivery?.bill_address_house_number ??
            delivery?.deliv_address_house_number,
          delivery?.bill_address_zipcode ?? delivery?.deliv_address_zipcode,
          delivery?.bill_address_city ?? delivery?.deliv_address_city,
          delivery?.accounting_email,
        ]
          .filter(Boolean)
          .join(", ")
      : deliveryAddress;

    setAddresses({
      "Delivery Address": deliveryAddress,
      "Billing Address": billingAddress,
    });
  }, [formData.deliveryAddress]);

  const dateFormat = (lang, date) => {
    if (lang && date) {
      const s = date.split("-");
      if (lang == "de") return `${s[2]}.${s[1]}.${s[0]}`;
      else return `${s[2]}/${s[1]}/${s[0]}`;
    }
    return "";
  };
  const formik = useFormik({
    initialValues: {
      termsAccepted: formData?.termsAccepted || false,
      noMarketing: formData?.noMarketing || false,
    },
    validationSchema: ReviewOrderSchema,
    onSubmit: async () => {
      try {
        setLoading(true);
        let cleanValue = germanToUSNumber(values?.energyConsumption)?.replace(
          /,/g,
          ""
        );
        let consumptionValue = Number(cleanValue);
        let data = {
          ...formData?.personalInformation,
          ...formData?.deliveryAddress,
          ...formData?.exchangeDetails,
          ...formData?.paymentDetails,
          is_business: values?.customerType == "business" ? true : false,
          tariff_type: localStorage.getItem("tariff_name"),
          annual_consumption: consumptionValue,
          id: localStorage.getItem("customer_id"),
        };
        const delivery = formData?.deliveryAddress;

        const billingAddress = {
          bill_address_street: delivery?.differentBillingAddress
            ? delivery?.bill_address_street
            : delivery?.deliv_address_street,

          bill_address_house_number: delivery?.differentBillingAddress
            ? delivery?.bill_address_house_number
            : delivery?.deliv_address_house_number,

          bill_address_zipcode: delivery?.differentBillingAddress
            ? delivery?.bill_address_zipcode
            : delivery?.deliv_address_zipcode,

          bill_address_city: delivery?.differentBillingAddress
            ? delivery?.bill_address_city
            : delivery?.deliv_address_city,
        };
        data = { ...data, ...billingAddress };
        if (data.payment_method == "bank_transfer")
          data.bank_data_iban = "DE 89 3704 0044 0532 0130 00";
        const res = await createCustomer({
          ...data,
          noMarketing: formData?.noMarketing,
          termsAccepted: formData?.termsAccepted,
        });
        if (res.success) {
          setStep(3);
        } else {
          let firstError;
          if (typeof res?.message === "object") {
            const firstKey = Object.keys(res.message)[0];
            firstError = res.message[firstKey][0];
          }
          setErrorMessage(firstError || res?.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 10000);
          setLoading(false);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error in form submission:", error);
        setLoading(false);
        setErrorMessage("An unexpected error occurred. Please try again.");
        setTimeout(() => setErrorMessage(""), 10000);
      }
    },
  });

  useEffect(() => {
    updateFormData({
      ...formData,
      termsAccepted: formik.values?.termsAccepted,
      noMarketing: formik.values?.noMarketing,
    });
  }, [formik.values?.termsAccepted, formik.values?.noMarketing]);

  return (
    <div className="container-fluid px-0">
      {/* Section Title */}
      <h2 className="fontSize32Regular lineHeight38 textgreen mb-1 mb-md-4 heading-text">
        {t("Your Order")}
      </h2>

      {/* Cards Section */}
      <div className="mb-3 mb-md-5">
        <div>
          <div className="col-12">
            <CardComponent
              image={require("../../assets/images/name-wbg.png")}
              data={{
                Name:
                  formData?.personalInformation?.first_name +
                  " " +
                  formData?.personalInformation?.last_name,
                Email: formData?.personalInformation?.email,
                "Phone number": formData?.personalInformation?.telephone,
                "Customer Id": formData?.personalInformation?.consumer_id,
                "User Name": formData?.personalInformation?.username,
              }}
              onClick={() => {
                setShowSave(true);
                setCurrentStep(0);
                setBackStep(1);
              }}
            />
            <CardComponent
              image={require("../../assets/images/delivery-add-wbg.png")}
              data={addresses}
              onClick={() => {
                setShowSave(true);
                setCurrentStep(1);
                setBackStep(2);
              }}
            />
            <CardComponent
              image={require("../../assets/images/smart-meter-wbg.png")}
              data={{
                // commenting as smart meter is not section of exchange details
                "Smart meter preview":
                  values?.hasSmartMeter == false ? t("no") : t("Yes"),
                "Desired delivery date": formData?.exchangeDetails
                  ?.preferred_delivery_start
                  ? dateFormat(
                      currentLanguage,
                      formData?.exchangeDetails?.preferred_delivery_start
                    )
                  : "",
                "Subscription reason": t(`${formData?.subscription}`),
                "Meter number": formData?.exchangeDetails?.meterId,
                "Meteringpoint ID": formData?.exchangeDetails?.meteringPointId,
                ...(formData?.provider &&
                  formData?.exchangeDetails?.subscription_reason == "E03" && {
                    "Current provider": formData?.provider,
                  }),
              }}
              onClick={() => {
                setShowSave(true);
                setCurrentStep(2);
                setBackStep(3);
              }}
            />
            <CardComponent
              image={require("../../assets/images/payment-wbg.png")}
              data={{
                "Payment Method": t(`${formData?.paymentlabel}`),
              }}
              onClick={() => {
                setShowSave(true);
                setCurrentStep(3);
                setBackStep(4);
              }}
            />
          </div>
        </div>
      </div>

      <h2 className="fontSize32Regular lineHeight38  mb-2 mb-md-4 textgreen heading-text">
        {t("Your Tariff")}
      </h2>
      <OfferCard
        values={values?.data?.find(
          (d) => d.tariff_name == localStorage.getItem("tariff_name")
        )}
        hide={hide}
        setHide={setHide}
      />
      {!hide && (
        <>
          {/* Checkboxes Section */}
          <div className="d-flex flex-column mt-2 mt-md-5">
            {/* Terms checkbox */}
            <div className="mb-md-4 mb-2">
              <div className="d-flex align-items-start gap-2">
                <TextInputFormik
                  className="form-check-input backgroundColorCommon borderColorlightgray cursor-pointer"
                  type="checkbox"
                  formik={formik}
                  field="termsAccepted"
                  customStyles="marginBottom0"
                />
                <label
                  className="form-check-label text-white fontSize14Medium lineHeight24"
                  htmlFor="termsAccepted"
                >
                  {currentLanguage == "de" ? (
                    <>
                      {t("I’ve read and agree to the")}{" "}
                      {/* Adding url for Terms & conditions please reverify with the url while moving to live */}
                      <a
                        href={
                          values?.customerType == "business"
                            ? "https://greenman.energy/wp-content/uploads/2025/09/AGB_Greenman_Energy_Geschaeftskunden.pdf"
                            : "https://greenman.energy/wp-content/uploads/2025/09/AGB_Greenman_Energy_Haushaltskunden.pdf"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-underline textGreen custom-pink-button"
                      >
                        {t("Terms & Conditions")}
                      </a>{" "}
                      {t("view details")}
                    </>
                  ) : (
                    <>
                      {t("I’ve read and agree to the")}{" "}
                      {/* Adding url for Terms & conditions please reverify with the url while moving to live */}
                      <a
                        href={
                          values?.customerType == "business"
                            ? "https://greenman.energy/wp-content/uploads/2025/09/AGB_Greenman_Energy_Geschaeftskunden.pdf"
                            : "https://greenman.energy/wp-content/uploads/2025/09/AGB_Greenman_Energy_Haushaltskunden.pdf"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-underline textGreen custom-pink-button"
                      >
                        {t("Terms & Conditions")}
                      </a>
                    </>
                  )}
                  *
                </label>
              </div>
              {(formik.submitCount > 0 || formik?.touched?.termsAccepted) &&
                formik?.errors?.termsAccepted && (
                  <p className="fontSize14Medium lineHeight1_2 text-pink marginNTop5 mb-0">
                    {t(`${formik.errors?.termsAccepted}`)}
                  </p>
                )}
            </div>

            {/* Marketing checkbox */}
            <div className="d-flex align-items-start gap-2 ">
              <TextInputFormik
                className="form-check-input borderColorlightgray backgroundColorCommon cursor-pointer"
                type="checkbox"
                formik={formik}
                field="noMarketing"
                customStyles="marginBottom0 "
              />
              <label
                className="form-check-label text-white fontSize14Medium lineHeight24 "
                htmlFor="noMarketing"
              >
                {currentLanguage == "de" ? (
                  <>
                    {t("review_bottom")}{" "}
                    <a
                      href={buildWebsiteUrl("/de/datenschutz")}
                      className="text-decoration-none textGreen custom-pink-button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("Privacy Statement")}
                    </a>
                  </>
                ) : (
                  <>
                    {t("review_bottom")}{" "}
                    <a
                      href={buildWebsiteUrl("/privacy-statement")}
                      className="text-decoration-none textGreen custom-pink-button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("Privacy Statement")}
                    </a>{" "}
                    {t("for more details.")}
                  </>
                )}
              </label>
            </div>
          </div>

          {/* Back/Next Buttons */}
          {loading ? (
            <div className="d-flex align-items-center justify-content-center">
              <Loader loading={loading} />
            </div>
          ) : (
            <>
              {errorMessage && (
                <p className="fontSize14Medium  text-pink mt-1 mb-0">
                  {t(`${errorMessage}`)}
                </p>
              )}
              <div className=" mt-4 mt-md-5">
                <BackNextButtons
                  currentStep={currentStep}
                  title={"Order Now"}
                  setCurrentStep={setCurrentStep}
                  onClick={formik.handleSubmit}
                  values={{ ...formData, ...values }}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ReviewOrderTab;
